module.exports = __webpack_public_path__ + "static/favicon-c19a030ef1b3107e3371f2a694c04f33.ico";